export const LAST_CONFIGURATION_ID_LOCAL_STORAGE_KEY =
  'pl-analyze-last-configuration-id';
export const SHOW_SUPER_RES_BADGE_LOCAL_STORAGE_KEY = 'pl-show-super-res-badge';

export enum MOSAICKING_ORDER {
  mostRecent = 'mostRecent',
  leastRecent = 'leastRecent',
  leastCC = 'leastCC',
}
export enum INTERPOLATOR {
  bilinear = 'BILINEAR',
  bicubic = 'BICUBIC',
  lanczos = 'LANCZOS',
  box = 'BOX',
  nearest = 'NEAREST',
}
